import { Component, Input } from '@angular/core';
import { UiText, UiTextTypeEnum } from '@ory/client';

@Component({
  selector: 'app-iam-with-ngzorro-messages',
  template: `
    @for (message of messages; track $index) {
      <span
        class="break-words"
        [class]="{
          'text-red': message.type === UiTextTypeEnum.Error,
        }"
      >
        {{ message.text }}
      </span>
    }
  `,
})
export class MessagesComponent {
  @Input() messages!: UiText[];
  readonly UiTextTypeEnum = UiTextTypeEnum;
}
